import { useCallback } from 'react'
import { offboardUser } from '../crud/engage.crud'
import useApiControls from './useApiControls'

const useEngageOffboarding = () => {
  const parseError = useCallback(
    (error) =>
      error?.response?.data?.message || // case request fails in backend
      error?.message, // if error is thrown in a task
    [],
  )

  const controls = useApiControls({ api: offboardUser, parseError }) // loading, error, data, callApi

  return {
    offboardUser: controls.callApi,
    isOffboardingUser: controls.loading,
    errorOffboardingUser: controls.error,
    offboardingUserData: controls.data,
    successOffboardingUser: controls.success,
    resetOffboardUserControls: controls.reset,
  }
}

export default useEngageOffboarding
